var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 6.73684 4.73684 6 6 6H18C19.2632 6 20 6.73684 20 8V16C20 17.2632 19.2632 18 18 18H6C4.73684 18 4 17.2632 4 16V8ZM2 8V16C2 18.2456 3.75439 20 6 20H18C20.2456 20 22 18.2456 22 16V8C22 5.75438 20.2456 4 18 4H6C3.75439 4 2 5.75438 2 8ZM22 16V8.31579C22 7.36842 21.0351 6.82456 20.2281 7.29824L12.7895 11.4211C12.2982 11.7018 11.7018 11.7018 11.2105 11.4211L3.77193 7.29824C2.96491 6.82456 2 7.36842 2 8.31579V16C2 18.2456 3.75439 20 6 20H18C20.2456 20 22 18.2456 22 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.75441c81.svg";
export { ForwardRef as ReactComponent };